import type { Method } from 'axios'

export enum OspeActivityType {
  ge = 1, // General exchanges
  se = 2, // Specialized exchanges
  be = 3, // Bilateral exchanges
  cp = 4, // Exchange for court presidents and chief prosecutors
  sv = 5, // Study visits
  lt = 6, // Long term training periods
  ap = 7, // AIAKOS programme
  cepol = 8, // CEPOL-EJTN exchanges
  cs = 9, // Court staff
  project = 10, // Project based exchanges
  et = 11, // Exchange template
}

export interface IdNamePair {
  id: number;
  name: string;
}

export interface OspeExchangePlace {
  id: number;
  countryName: string;
  institutionName: string;
  institutionTag: string;
  activityType: string;
  exchangeType: string | null;
  languages: string;
  functions: string;
  specialisation?: string | null;
  availablePlaces: string;
  duration: string;
  additionalInformation: string;
  activityPlacePeriodId: number | null;
  activityPlacePeriodDate: string | null;
  activityPlacePeriodLanguage: string | null;
}

export interface OspeExchangeChoice extends OspeExchangePlace {
  activityId?: number;
  anyLanguageOnly?: boolean;
  languageItems: IdNamePair[];
  exchangeTypeItems: IdNamePair[];
  durationItems: IdNamePair[];
  languageId: number | null;
  exchangeTypeId: number | null;
  durationId: number | null;
  cjeuAllocationItems: IdNamePair[];
  cjeuAllocationId: number | null;
  preferredPeriod: string | null;
  specialInterest: string | null;
  errorMessages: string[];
  withSubSpecialisations?: boolean;
  allowPreMatchedParticipantToBeNamed?: boolean;
  askAboutHostingMultipleCounterparts?: boolean;
  preMatchCounterpartName?: string | null;
  hasMultipleCounterparts?: boolean | null;
}

export interface OspeShortTermApplication {
  activityTypeId: number | null;
  activityCategoryId: number | null;
  functionId: number | null;
  courtStaffWorkplaceId: number | null;
  specialisationId: number | null;
  subSpecialisationIds: number[];
  otherSubSpecialisation: string | null;
  supportingDocument: {
    id: string;
    filename: string;
    url?: string;
  };
  firstChoice: OspeExchangeChoice | null;
  secondChoice: OspeExchangeChoice | null;
  thirdChoice: OspeExchangeChoice | null;
  nationalityId: number | null;
  germanyLandId: number | null;
  allocateToOtherCountry: boolean | null;
}

export interface OspeLongTermApplication {
  choice: OspeExchangeChoice | null;
}

export interface OspeStudyVisitChoice {
  id: number;
  institutionName: string;

  activityPlacePeriodId: number;
  activityPlacePeriodDate: string;
  activityPlacePeriodLanguage: string;

  specialInterest: string;

  errorMessages: string[];
}

export interface OspeStudyVisitPlacePeriod {
  id: number;
  dates: string;
  language: string;
  availablePlaces: number;
}

export interface OspeStudyVisitPlace {
  id: number;
  institutionName: string;
  periods: OspeStudyVisitPlacePeriod[];
}

export interface OspeStudyVisitApplication {
  choice: OspeStudyVisitChoice | null;
}

export interface Confirmation {
  id: string;
  type: "confirmations" | "confirmation-results" | null;
  title?: string | null;
  displayMode?: "alert" | null;
  alertType?: string | null;
  message: string;
  actionTitle: string;
  actionMessage: string;
  actionButtonType?: string;
  actionRequest?: {
    method?: Method;
    params?: any;
    paramsFn?: () => any;
    url: string;
  };
}

export interface ConfirmationResult {
  id: string;
  type: string;
  isSuccess: boolean;
  message: string;
  details?: string[];
  url?: string;
}
